module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("a4YYL"))).then(() => parcelRequire('4wpWc'));